import { render, staticRenderFns } from "./areaLogin.vue?vue&type=template&id=6ebad26b&scoped=true&"
import script from "./areaLogin.vue?vue&type=script&lang=js&"
export * from "./areaLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebad26b",
  null
  
)

export default component.exports